<div class="kolq-page">
  <header class="kolq-header">
    <img class="kolq-logo" src="/assets/img/login-logo.png" alt="Barkani" />
  </header>

  <main class="kolq-main">
    <div class="kolq-card">
      <div *ngIf="loading" class="text-center py-5 text-muted">
        Loading questionnaire…
      </div>

      <div *ngIf="!loading && error" class="alert alert-danger mb-0">
        {{error}}
      </div>

      <ng-container *ngIf="!loading && !error">
        <div *ngIf="submitted; else formBlock" class="text-center py-4">
          <div class="kolq-check">&#10003;</div>
          <h3 class="mb-2">Thank you!</h3>
          <p class="text-muted mb-0">Your KOL questionnaire has been submitted successfully.</p>
        </div>

        <ng-template #formBlock>
          <div class="kolq-title">
            <h2 class="mb-1">KOL Questionnaire</h2>
            <p class="text-muted mb-0" *ngIf="contact">
              {{contact.first_name}} {{contact.last_name}}<span *ngIf="company"> &mdash; {{company.name}}</span>
            </p>
          </div>

          <div *ngIf="!form" class="alert alert-warning mb-0">
            There is no questionnaire configured for your profile yet. Please contact the bureau for assistance.
          </div>

          <form *ngIf="form" (ngSubmit)="onSubmit()" #questionnaireForm="ngForm" novalidate>
            <div class="kolq-formname">{{form.name}}</div>

            <div *ngIf="!screens.length" class="text-muted">
              This questionnaire has no questions yet.
            </div>

            <ng-container *ngIf="screens.length">
              <div class="kolq-progress">
                <div class="kolq-progress-bar"
                  [style.width.%]="((currentScreenIndex + 1) / screens.length) * 100"></div>
              </div>
              <div class="kolq-step text-muted">Step {{currentScreenIndex + 1}} of {{screens.length}}</div>

              <div *ngIf="screens[currentScreenIndex] as screen">
                <div class="form-group mb-3" *ngFor="let q of screen.questions">
                  <ng-container *ngIf="getQuestion(q.question_id) as question">
                    <app-question [question]="question" [answers]="data"></app-question>
                  </ng-container>
                </div>
              </div>

              <div class="kolq-actions">
                <button type="button" class="btn btn-outline-secondary"
                  (click)="prevScreen()" [disabled]="currentScreenIndex === 0">
                  &larr; Back
                </button>

                <button *ngIf="!isLastScreen" type="button" class="btn btn-primary"
                  (click)="nextScreen()">
                  Next &rarr;
                </button>

                <button *ngIf="isLastScreen" type="submit" class="btn btn-primary"
                  [disabled]="submitting">
                  {{submitting ? 'Submitting…' : 'Submit'}}
                </button>
              </div>
            </ng-container>
          </form>
        </ng-template>
      </ng-container>
    </div>

    <footer class="kolq-footer">
      &copy; 2026 Barkani
    </footer>
  </main>
</div>
